export enum GameOrientationEnum {
  /** @des 横屏 */
  Landscape = 1,
  /** @des 竖屏 */
  Portrait = 2,
}